/**
 * The trust strip.
 *
 * The brief asked for employer logos. There are no customers yet, and putting
 * company marks on a landing page implies an endorsement that does not exist —
 * which is the one thing this product cannot afford to fake.
 *
 * So it shows what is actually true and happens to be a better signal for a
 * job seeker: the applicant tracking systems NextOpp reads directly. These are
 * the four in job_providers.PROVIDERS, not a wishlist.
 */
// The providers in job_providers.PROVIDERS, trimmed to what fits on one line.
// Naming boards we cannot read would be the same class of claim the rest of
// this site refuses to make.
const BOARDS = ["Greenhouse", "Lever", "Ashby", "Workable", "Workday", "SmartRecruiters"];

export default function BoardStrip({ dark = false }) {
  return (
    <div className="flex flex-wrap items-center gap-x-6 lg:gap-x-7 gap-y-2" data-testid="board-strip">
      <span className={`text-xs uppercase tracking-[0.18em] font-bold ${dark ? "text-white/40" : "text-stone-600"}`}>
        Reads job boards directly
      </span>
      {BOARDS.map((b) => (
        <span key={b} className={`font-heading text-base lg:text-lg font-bold tracking-tight ${dark ? "text-white/55" : "text-stone-600"}`}>
          {b}
        </span>
      ))}
    </div>
  );
}
